"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostType = void 0;
var PostType;
(function (PostType) {
    PostType["Image"] = "Image";
    PostType["Video"] = "Video";
    PostType["Story"] = "Story";
    PostType["Text"] = "Text";
    PostType["LongVideo"] = "Long Video";
    PostType["ShortVideo"] = "Short Video";
    PostType["BlogPost"] = "Blog Post";
})(PostType = exports.PostType || (exports.PostType = {}));
//# sourceMappingURL=postType.enum.js.map